import React from 'react';
import { motion } from 'framer-motion';
import { Check, TrendingUp, Clock, Users, DollarSign, Brain } from 'lucide-react';
export function StorySection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-12 px-4 bg-brand-light" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-129">
          <div className="bg-white p-6 rounded-2xl shadow-md border-t-4 border-brand-green" data-id="element-130">
            <h3 className="text-xl font-bold text-brand-dark mb-4" data-id="element-131">
              Para quién es este sistema
            </h3>
            <ul className="space-y-2.5" data-id="element-132">
              {['Agentes inmobiliarios independientes', 'Corredores y asesores de bienes raíces', 'Equipos pequeños', 'Nuevos agentes que quieren empezar bien'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-133">
                  <Check className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-134" />
                  <span className="text-gray-700 font-medium" data-id="element-135">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-md border-t-4 border-brand-gold" data-id="element-136">
            <h3 className="text-xl font-bold text-brand-dark mb-4" data-id="element-137">
              Qué vas a lograr con este Kit
            </h3>
            <ul className="space-y-2.5" data-id="element-138">
              {[{
              icon: <TrendingUp className="w-4 h-4 text-brand-gold" data-id="element-139" />,
              text: 'Cerrar más ventas sin trabajar más horas'
            }, {
              icon: <Clock className="w-4 h-4 text-brand-gold" data-id="element-140" />,
              text: 'Hacer seguimiento en el momento justo'
            }, {
              icon: <Users className="w-4 h-4 text-brand-gold" data-id="element-141" />,
              text: 'No perder nunca más un lead caliente'
            }, {
              icon: <DollarSign className="w-4 h-4 text-brand-gold" data-id="element-142" />,
              text: 'Recuperar comisiones que se te escapan'
            }, {
              icon: <Brain className="w-4 h-4 text-brand-gold" data-id="element-143" />,
              text: 'Trabajar con claridad y sin estrés'
            }].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-144">
                  {item.icon}
                  <span className="text-gray-700 font-medium" data-id="element-145">{item.text}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center" data-id="element-146">
          <p className="text-lg text-gray-600 mb-2" data-id="element-147">Porque al final…</p>
          <p className="text-xl font-bold text-brand-dark mb-1" data-id="element-148">
            No gana el agente con más leads.
          </p>
          <p className="text-2xl font-heading font-black text-brand-blue bg-brand-blue/10 inline-block px-5 py-2 rounded-xl" data-id="element-149">
            Gana el agente que mejor gestiona sus leads.
          </p>
        </motion.div>
      </div>
    </section>;
}